const doc = [({"de":({"copy":"Kopieren", "copied":"Kopiert"}), "fr":({"copy":"Copier", "copied":"Copié"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;